"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("antd/lib/message/style");
var _message2 = _interopRequireDefault(require("antd/lib/message"));
var _react = _interopRequireWildcard(require("react"));
var _loadJs = require("../../utils/loadJs");
var _captcha = require("../../consts/captcha");
var _Portal = _interopRequireDefault(require("../Portal"));
require("./style.css");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var WrapTencent = function WrapTencent() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_captcha_tencent_wrap",
    id: "gy_captcha_tencent_wrap"
  });
};
var Tencent = function Tencent(props) {
  var balanceCode = props.balanceCode,
    captchaItem = props.captchaItem,
    onSubmit = props.onSubmit,
    onClose = props.onClose,
    errorHandler = props.errorHandler,
    _props$mask = props.mask,
    mask = _props$mask === void 0 ? true : _props$mask,
    refreshCaptcha = props.refreshCaptcha,
    onChange = props.onChange,
    publicIp = props.publicIp;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    visibleSuccess = _useState2[0],
    setVisibleSuccess = _useState2[1];
  var handleCaptcha = function handleCaptcha() {
    var tencentCaptcha = new window.TencentCaptcha(document.getElementById('gy_captcha_tencent_wrap'), _captcha.TENCENT_APP_ID, function (res) {
      if (res.ret === 0) {
        var captcha = res.randstr,
          cookies = res.ticket;
        onSubmit(_objectSpread({
          captcha: captcha,
          cookies: cookies,
          balanceCode: balanceCode,
          type: _captcha.CAPTCHA_TYPE.tencent
        }, publicIp && {
          publicIp: publicIp
        }));
        setVisibleSuccess(true);
        return;
      } else if (res.ret === 2) {
        onClose();
        // 关闭
        return;
      }
      errorHandler && errorHandler({
        status: 'error'
      });
    }, {
      type: mask ? 'popup' : 'embed'
    });
    // 显示验证码
    tencentCaptcha.show();
  };
  /**
   * 初始化腾讯验证码
   */
  var tencentCaptchaInit = function tencentCaptchaInit() {
    if (window.TencentCaptcha) {
      handleCaptcha();
      return;
    }
    (0, _loadJs.loadJs)({
      src: 'https://turing.captcha.qcloud.com/TCaptcha.js',
      id: 'CaptchaId',
      cb: function cb() {
        try {
          handleCaptcha();
        } catch (error) {
          _message2.default.error('加载异常');
          errorHandler && errorHandler({
            status: 'error'
          });
        }
      }
    });
  };
  (0, _react.useEffect)(function () {
    if (Object.keys(captchaItem).length || refreshCaptcha) {
      tencentCaptchaInit();
    }
    if (refreshCaptcha) {
      setVisibleSuccess(false);
    }
  }, [captchaItem, refreshCaptcha]);
  (0, _react.useEffect)(function () {
    onChange && onChange({
      completed: visibleSuccess
    });
  }, [visibleSuccess]);
  return !mask && props.getContainer ? /*#__PURE__*/_react.default.createElement(_Portal.default, {
    container: props.getContainer
  }, /*#__PURE__*/_react.default.createElement(WrapTencent, null), visibleSuccess && /*#__PURE__*/_react.default.createElement("div", {
    className: "gy_captcha_tencent_success"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "gy_captcha_tencent_success_img",
    src: "//img.gyyxcdn.cn/h5game/paysuccess.png",
    alt: ""
  }), /*#__PURE__*/_react.default.createElement("p", null, "\u9A8C\u8BC1\u7801\u6821\u9A8C\u6210\u529F"))) : /*#__PURE__*/_react.default.createElement(WrapTencent, null);
};
var _default = Tencent;
exports.default = _default;